import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type PrescreenedPosition = {
  positionId: number
  positionName: string
  companyId: number
  companyName: string
  createdAt: string
}

export type GetPrescreenedPositionsParams = {
  cursor?: string
  direction?: 'next' | 'previous'
  pageSize?: number
}

export type GetPrescreenedPositionsResponse = {
  items: PrescreenedPosition[]
  previousCursor: string | null
  nextCursor: string | null
}

export async function getPrescreenedPositions(
  userId: number,
  params: GetPrescreenedPositionsParams = {}
): Promise<GetPrescreenedPositionsResponse> {
  const result = await api.get<GetPrescreenedPositionsResponse>(
    `/admin/user/${userId}/prescreened_positions`,
    {
      params: {
        cursor: params.cursor,
        direction: params.direction,
        page_size: params.pageSize,
      },
      paramsSerializer: queryParamSerializer,
    }
  )
  return result.data
}
